import React, { useState } from "react";
import { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import ClearIcon from "@material-ui/icons/Clear";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import InputBase from "@material-ui/core/InputBase";
import SearchIcon from "@material-ui/icons/Search";
import ListSubheader from "@material-ui/core/ListSubheader";
import InputAdornment from "@material-ui/core/InputAdornment";
import { IconButton, TextField } from "@material-ui/core";
import Menu from "@material-ui/core/Menu";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import MenuItem from "@material-ui/core/MenuItem";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import styles from "../../../UI/css/ReportModal.module.css";
import { CircularProgress } from "@material-ui/core";
import { useDispatch, addContexts, useSelector } from "../../../Redux";
import secureLocalStorage from "react-secure-storage";
import { useTranslation } from "react-i18next";
import { GetStateFromData } from "../../../components/CustomHooks/CustomHooks";
import { getTabIndex } from "../../../components/IFormDesignerLayout/IFormDesignerLogic";
import { functions } from "../../../components/IFormDesignerLayout/ApplicationAPI/applicationApi";
import secureSessionStorage from "../../../utils/secureSessionStorage";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: "100%",
    backgroundColor: theme.palette.background.paper,
    position: "relative",
    overflow: "auto",
    maxHeight: "252px",
    paddingBottom: 0,
    margin: 0,
  },
  listSection: {
    backgroundColor: "inherit",
  },
  ul: {
    backgroundColor: "inherit",
    padding: 0,
  },
  reportitem: {
    height: "36px",
    borderBottom: "1px solid #C4C4C4",

    "&:hover": {
      backgroundColor: "#0072c60f",
      cursor: "pointer",
    },
  },
  reportitemSelected: {
    height: "36px",
    borderBottom: "1px solid #C4C4C4",
    backgroundColor: "#0072c60f",

    "&:hover": {
      backgroundColor: "#0072c60f",
      cursor: "pointer",
    },
  },
  paper: {
    direction: style => style?.translationStyles1 ? "rtl" : "initial",
    position: "absolute",
    width: "793px",
    height: "437px",
    top: "50%",
    left: "50%",
    transform: `translate(-50%, -50%)`,
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "0px 0px 10px #51515180",
    opacity: "1",
    
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,

    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  listItemText: {
    "& .MuiListItemText-primary": {
      //color: "red",
      color: "#000000",
      textAlign: "left",
      fontSize: "16px",
      fontFamily: "Open Sans",
      fontWeight: "400",
      letterSpacing: "0px",
      opacity: "1",
    },
  },

  listItemText2: {
    marginLeft : "2% !important",


    "& .MuiListItemText-secondary": {
      direction: "ltr",
      color: "#000000",
      textAlign: "left",
      fontSize: "15px",
      fontFamily: "Open Sans",
      fontWeight: "400",
      letterSpacing: "0px",
      opacity: "1",
      textOverflow: "ellipsis !important",
      overflow: "hidden !important",
      maxWidth: "90px !important",
      whiteSpace: "nowrap",
    },
  },

  keydownarrow1: {
    // marginTop: "-3% !important",
    marginRight : "6% !important"
  },
  keydownarrow2: {
    marginTop: "3% !important",
    marginRight : "1% !important"
  },
  TestingClass:{
    top:"2.5em !important",
    //left:"100px !important",
    //right:"100px important",
    maxWidth:"16.5em !important",
    height : "43em !important"
  },
  menuItemName: {


  }
}));

// const options = ["All Reports", "Filter 1", "Filter 2", "Filter 3"];

const ReportModal = (props) => {
 const activeTabIndex = getTabIndex(props?.data);
  const translationStyles1=window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA";
  const classes = useStyles({translationStyles1});
  const [filter, setFilter] = React.useState("");
  const {t}=useTranslation();


  const contexts = GetStateFromData(props.containerId);

  const reduxContexts = contexts;

  const { sessionIdCurrent, microFrontendData, formMataData,updateJson } =
    contexts.contexts;
    const {updatedComponentInFormState} =updateJson;
  const [data, setData] = React.useState([]);
  const [enableNext, setEnableNext] = React.useState();
  const [enablePrev, setEnablePrev] = React.useState();
  const [dataObj, setDataObj] = React.useState({});

  // const [sessionIdConnection, setSessionIdConnection] = React.useState();

  const [options, setOptions] = React.useState([]);

  const [view, setView] = React.useState([]);

  const [showLoader, setShowLoader] = React.useState(false);

  // console.log("props data Id Is", sessionIdCurrent);

  //   const [data, setData] = React.useState([{report_index: '526', report_name: '1_Sample_drilldown1'},
  //   {report_index: '527', report_name: '1_Sample_drilldown2'},
  //   {report_index: '528', report_name: '1_Sample_drilldown3'},

  // ]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedIndex, setSelectedIndex] = React.useState(0);

  const [selectedReportId, setSelectedReportId] = React.useState();
  
  const[dropDownWidth, setDropDownWidth] = React.useState(0);

  const [catid,setCatId] = useState("");

  useEffect(() => {
    // console.log("abcdefghi ", props.data.selectId);
    const ddwidth = document.querySelector(".ListHeader").clientWidth;
    setDropDownWidth(ddwidth);
  }, []);

  useEffect(() => {
    // console.log("abcdefghi ", props.data.selectId);
    if (props.data.selectId !== undefined) {
      setSelectedReportId(props.data.selectId);
      if (!window?.loadMicroFrontend) {
        window.loadIntegrator_bam();
      }
    }
  }, []);


  var token = microFrontendData?.token || formMataData?.token || undefined;
  if (token === undefined) {
    // const launchpadKey = secureLocalStorage.getItem("launchpadKey");
    const jwtToken =
      JSON.parse(secureLocalStorage.getItem(window.isPortalLive ?  `launchpadKey_${window.applicationName}` || `launchpadKey_bypass_${window.applicationName}`  || "launchpadKey" : "launchpadKey"))?.token ||
    undefined;
    // const jwtToken = JSON.parse(launchpadKey)?.token;
    token = jwtToken;
  }

  // const [reportLength , setReportLength] = useState(0);
  // const[startIdx,setStartIdx] = useState(0);
  // const [endIdx,setEndIdx] = useState(0);
  // var reportBatchSize = 20;

  

  useEffect(() => {
    // var token = microFrontendData?.token || formMataData?.token || undefined;
    // if (token === undefined) {
    //   const launchpadKey = localStorage.getItem("launchpadKey");
    //   const jwtToken = JSON.parse(launchpadKey)?.token;
    //   token = jwtToken;
    // }
    fetch("/bam-ws/app/getreportlist", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${token}`,
      },
      body: JSON.stringify({
        // "category": "A",
        // "filter": "",
        // "opr": "0",
        // "last_index": "",
        // "last_name": "",
        // "type": "Design",
        // "last_blockedstatus": "",
        // "hide_blocked": false,
        // "showblocked_top": false,
        // "sort_order": "a",
        // "blocked_filter": false,
        // "healthstatus_code": "",
        // "category_id": "0"

        category: "CR",
        filter: "",
        opr: "0",
        last_index: "",
        last_name: "",
        type: "Design",
        last_blockedstatus: "",
        hide_blocked: false,
        showblocked_top: false,
        sort_order: "a",
        healthstatus_code: "",
        category_id: "1000",
        category_name: "General Reports"
        // blocked_filter: false,
        // ignoreApplicationId: "Y",
       
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (content) {
        setCatName("General Reports")
        setCatId("1000")
        setData(content.data.reports);
        setDataObj(content.data)
        setEnableNext(content.data.enable_next);
        setEnablePrev(content.data.enable_prev);

        // setReportLength(content.data.reports.length);
        // setStartIdx(0);
        // if(content.data.reports.length>reportBatchSize)
        // {
        //   setEndIdx(reportBatchSize);
        //   setEnableNext(true);
        // }
        
        // else if(
        //   // content.data.reports.length<=reportBatchSize && 
        //     content.data.reports.length>0)
        // {
        //   // setEnableNext(false)
        //   setEndIdx(content.data.reports.length);
        // }
       
      
      })
      .then((res) => {
        fetch("/bam-ws/app/getcategorylist", {
          method: "post",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({
            screenid: "ReportDesigner",
          }),
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (content) {
            // console.log("bam login In", content);
            // console.log("bam login In", content.data);
            // console.log("bam login In", content.data.category);
            setOptions(content.data.category);
            setView(content)
            // setData(content.data.reports);
          })
          .catch((error) => {
            console.log("error is", error);
          });
      })
      .catch((err) => {
        console.log("error is", err);
      });
  }, []);

  // const [options,  setOptions] = React.useState([
  //   {category_index: '19', category_name: 'abcdefghji'},
  //   {category_index: '27', category_name: 'aaaaaabcdefgr'},
  //   {category_index: '30', category_name: 'abcdefghijkl'},
  //   {category_index: '29', category_name: 'arjunarjun'},
  //   {category_index: '33', category_name: 'catnmmahdj'},
  //   {category_index: '34', category_name: 'cat2erfkrnk'},
  //   {category_index: '30', category_name: 'abcplokngsf'},

  // ]);

  const [sessionId, setSessionId] = React.useState(0);
  const [listItemDefaultText,setListItemDefaultText] = useState(false);
  const [lengthListItemText,setLengthListItemText] = useState(false);
  const [name, setName] = React.useState("");
  const [catname,setCatName] = useState("");
 
  const handleClickListItem = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (event, index) => {
    // console.log("Index Is ", index);
    setSelectedIndex(index);
    
    setListItemDefaultText(true)
    // console.log("Index Is ",options[index]);
    // console.log("Index Is ",options[index].category_index);
    // console.log("Index Is ",options[index].category_name);

    fetch("/bam-ws/app/getreportlist", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${token}`,
      },
      body: JSON.stringify({
        category : 'CR',
        category_name: options[index].category_name,
        category_id: options[index].category_index,
        filter: filter,
        healthstatus_code: "",
        hide_blocked: false,
        last_blockedstatus: "",
        last_index: dataObj?.last_index,
        last_name: dataObj?.last_name,
        opr: 0,
        showblocked_top: false,
        type: "Design",
        sort_order: "a",
        // blocked_filter: false,
        // ignoreApplicationId: "Y"
      }),
    })
      .then(function (response) {

        return response.json();
      })
      .then(function (content) {
        // console.log("bam login In", content);
        // console.log("bam login In", content.data);
        // console.log("bam login In", content.data.reports);
        setCatName(options[index].category_name);
        setCatId( options[index].category_index)
        console.log("cccccccccccccc",catid,catname)
        setData(content.data.reports);
        setDataObj(content.data)
        setEnableNext(content.data.enable_next);
        setEnablePrev(content.data.enable_prev);

        // setReportLength(content.data.reports.length);
        // setStartIdx(0);
        // if(content.data.reports.length>reportBatchSize)
        // {
        //   setEndIdx(reportBatchSize);
        //   setEnableNext(true);
        // }
        
        // else if(
        //   // content.data.reports.length<=reportBatchSize && 
        //   content.data.reports.length>0)
        // {
        //   // setEnableNext(false)
        //   setEndIdx(content.data.reports.length);
        // }
        
        if(content.data.reports.length==0){
          functions?.showMess(["No Report Available"],"error");
        }
      })
      .catch((err) => {
        console.log("error is", err);
      });
    setAnchorEl(null);
    (options[index].category_name.length===0)?setLengthListItemText(true):setLengthListItemText(false)
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  function nextPageReport() {
    // console.log(data.length!==0 && data?.[data.length-1]?.report_name);

    if (enableNext) {
      setShowLoader(true);
      fetch("/bam-ws/app/getreportlist", {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          category: "CR",
          filter: "",
          opr: "1",
          last_index: dataObj?.last_index,
          last_name: dataObj?.last_name,
          type: "Design",
          last_blockedstatus: dataObj?.last_blocked_status,
          hide_blocked: false,
          showblocked_top: false,
          sort_order: "a",
          healthstatus_code: "",
          category_id: catid,
          category_name: catname,
          // blocked_filter: false,
          // ignoreApplicationId: "Y"
        }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (content) {
          // console.log("bam login In", content);
          // console.log("bam login In", content.data);
          // console.log("bam login In", content.data.reports);
          setShowLoader(false);
          setData(content.data.reports);
          setDataObj(content.data);
          
          setEnableNext(content.data.enable_next);
          setEnablePrev(content.data.enable_prev);

          // if(content.data.reports.length-endIdx>reportBatchSize)
          // {
          //   setEnableNext(true)
          //   setEnablePrev(true);
          //   setStartIdx(endIdx+1);
          //   setEndIdx(endIdx+reportBatchSize+1)
          // }
          // else if((content.data.reports.length-endIdx<=reportBatchSize && content.data.reports.length-endIdx>0)){
          //   setEnableNext(false);
          //   setEnablePrev(true);
          //   setStartIdx(endIdx+1);
          //   setEndIdx(content.data.reports.length);
          // }
           
        })
        .catch((err) => {
          console.log("error is", err);
        });
    }
  }

  function previousPageReport() {
    if (enablePrev) {
      setShowLoader(true);
      fetch("/bam-ws/app/getreportlist", {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          category: "CR",
          filter: "",
          opr: "2",
          last_index: dataObj?.first_index,
          last_name: dataObj?.first_name,
          type: "Design",
          last_blockedstatus: dataObj?.last_blocked_status,
          hide_blocked: false,
          showblocked_top: false,
          sort_order: "a",
          healthstatus_code: "",
          category_id: catid,
          category_name: catname,
          // blocked_filter: false,
          // ignoreApplicationId: "Y"
        }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (content) {
          // console.log("bam login In", content);
          // console.log("bam login In", content.data);
          // console.log("bam login In", content.data.reports);
          setShowLoader(false);
          setData(content.data.reports);
          setDataObj(content.data)
          setEnableNext(content.data.enable_next);
          setEnablePrev(content.data.enable_prev);

          // if(startIdx>0)
          // {
          //   if(startIdx - reportBatchSize > reportBatchSize)
          //   setEnablePrev(true);

          //   setEnableNext(true)
          //   setStartIdx(startIdx-(reportBatchSize+1));
          //   setEndIdx(startIdx-1);
          // }
          // else if(startIdx === 0)
          // {
          //   setEnablePrev(false)
          //   setEnableNext(true)
          // }
         

          // if(content.data.reports.length-endIdx>5)
          // {
          //   setEnableNext(true)
          //   setStartIdx(endIdx+1);
          //   setEndIdx(endIdx+5)
          // }
          // else if((content.data.reports.length-endIdx<5 && content.data.reports.length-endIdx>0)){
          //   setEnableNext(false);
          //   setStartIdx(endIdx+1);
          //   setEndIdx(content.data.reports.length);
          // }
        })
        .catch((err) => {
          console.log("error is", err);
        });
    }
  }

  function searchWord() {
    fetch("/bam-ws/app/getreportlist", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${token}`,
      },
      body: JSON.stringify({
        category: "CR",
        category_id: catid,
        category_name: catname,
        filter: filter,
        healthstatus_code: "",
        hide_blocked: false,
        last_blockedstatus: "",
        last_index: dataObj?.last_index,
        last_name: dataObj?.last_name,
        opr: 0,
        showblocked_top: false,
        type: "Design",
        sort_order: "a",
       // blocked_filter: false,
      //  ignoreApplicationId: "Y"
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (content) {
        // console.log("bam login In", content);
        // console.log("bam login In", content.data);
        // console.log("bam login In", content.data.reports);
        setData(content.data.reports);
        setEnableNext(content.data.enable_next);
        setEnablePrev(content.data.enable_prev);
        setDataObj(content.data)

        if(content.data.reports?.length === 0){
        functions?.showMess(["No Report Available, Please try different filter"],"error");
       }
      

        // setReportLength(content.data.reports.length);
        // setStartIdx(0);
        // if(content.data.reports.length>reportBatchSize)
        // {
        //   setEndIdx(reportBatchSize);
        //   setEnableNext(true);
        // }
        
        // else if((content.data.reports.length<=reportBatchSize && content.data.reports.length>0))
        // {
        //   setEnableNext(false)
        //   setEndIdx(content.data.reports.length);
        // }
      })
      .catch((err) => {
        console.log("error is", err);
      });
  }

  function getParticularCategoryList() {}

  //   const dataMicro={
  //     "MicroFrontends":[
  //         {
  //             "ReportViewer":{
  //                 "Container": "false",
  //                 "Reports":[
  //                         {
  //                         "ReportId": selectedReportId,
  //                         "ReportParams":{
  //                             "EmbeddedView":"00000000"
  //                         },
  //                          "ContainerId":props.data && props.data.id
  //                     }
  //                 ]
  //             }
  //         }
  //     ]
  // }

  // useEffect(()=>{
  //   window.loadIntegrator();
  // },[])

  // // console.log("sessionId 123", props.sessionIdConnection);

  // window.getMicroApps = function (microAppsHandler) {
  //   var microAppsJSON = {
  //        "AuthData": {
  //       //  "Locale":"en_US",
  //       //  "UserIndex":"3",
  //       //  "UserId":"supervisor",
  //       //  "SessionId":sessionIdConnection,
  //       //  "CabinetName":"bamdev5sp2",
  //       //  "PersonalName":"",
  //       //   "FamilyName":"",
  //       //   "ClientGMTOffset":"",
  //       //   "ServerGMTOffset":"",
  //       //   "BatchSize":"10",
  //       //   "ThemeId":"0",
  //       //   "UDBEncrypt":"N"
  //         "locale": "en_US",
  //         "user_index": "1",
  //         "user_name": "supervisor",
  //         // "session_id": sessionIdConnection,
  //         "session_id": props.sessionIdConnection,
  //         "cabinet_name": "bamdev5sp2",
  //         "personal_name": "Supervisor",
  //         "family_name": "",
  //         "client_gmt_offset": 0,
  //         "batch_size": 100,
  //         "server_gmt_offset": 330,
  //         "theme_id": "0",
  //         "eds": "N",
  //         "udb_encrypt": "N"
  //     },
  //       "MicroApps": [
  //           {
  //               "Module": "BAM",
  //               "MicroFrontends": [
  //                   {
  //                       "Component": "ReportViewer",
  //                       "InFrame": true,
  //                       "Props": [
  //                           {
  //                               "ReportId": selectedReportId,
  //                               "ContainerId": props.data && props.data.id
  //                           }
  //                       ]
  //                   }
  //               ]
  //           }
  //       ]
  //   }
  //   microAppsHandler({...microAppsJSON});
  // }

  // window.loadFormBuilder = function (passedData){
  //   var props = {
  //   "Module": "FORMBUILDER",
  //   "Component": "App",
  //   "InFrame": false,
  //   "ContainerId": "mf_formBuilder",
  //   "Callback":"onReportLoad",
  //   "passedData": passedData
  //   }
  //   window.loadMicroFrontend(props);
  // }

  // function loaderScript() {
  //   // console.log("select Report is 11 222", selectedReportId);
  //   const script = document.createElement('script');
  //   script.type= "application/json";
  //   script.id="data";
  //   // script.textContent = dataMicro;
  //   script.innerText = dataMicro;
  //   // console.log("select Report is 11", selectedReportId);
  //   script.onload= () => {
  //     // console.log("select Report is 22", selectedReportId);
  //     window.loadIntegrator();
  //   }
  //   document.head.appendChild(script);
  //   }

  // window.getMicroApps = function (microAppsHandler) {
  //   var microAppsJSON = {
  //        "AuthData": {
  //         "locale": "en_US",
  //         "user_index": "2106",
  //         "user_name": "bhavya",
  //         "session_id": sessionIdCurrent,
  //         "cabinet_name": "ibps5sp1p3feb1",
  //         "personal_name": "New User",
  //         "family_name": "",
  //         "client_gmt_offset": 0,
  //         "batch_size": 20,
  //         "server_gmt_offset": 330,
  //         "theme_id": "0",
  //         "eds": "N",
  //         "udb_encrypt": "N"
  //     },
  //       "MicroApps": [
  //           {
  //               "Module": "BAM",
  //               "MicroFrontends": [
  //                   {
  //                       "Component": "ReportViewer",
  //                       "InFrame": true,
  //                       "Props": [
  //                           {
  //                               "ReportId": selectedReportId,
  //                               "ContainerId": props.data && props.data.id
  //                           }
  //                       ]
  //                   }
  //               ]
  //           }
  //       ]
  //   }
  //   microAppsHandler({...microAppsJSON});
  // }
  function callBack_func() {
    console.log("callBack_func");
  }

  function loadReport() {
    const language = window?.psh_configs?.selectedLanguage;

    // const secureAutherization = secureLocalStorage.getItem("Authorization");
    // const secureAutherization1 = secureLocalStorage.getItem("launchpadKey");
    const jwtToken =
      JSON.parse(secureLocalStorage.getItem(window.isPortalLive ?  `launchpadKey_${window.applicationName}`|| `launchpadKey_bypass_${window.applicationName}` ||  "launchpadKey" : "launchpadKey"))?.token ||
    secureSessionStorage.getItem("Authorization") ||
    undefined;
    // const jwtToken = secureAutherization || JSON.parse(secureAutherization1)?.token || undefined;
    // if(callBack_func===undefined){
    //     callBack_func=callBack_func;
    // }
    var propsData = {
      Module: "BAM",
      token: jwtToken,
      Component: "ReportViewer",
      InFrame: true,
      ContainerId: props.data.id,
      // "data": { "ReportId": selectedReportId },
      locale: "en_US",
      // "passedData": { "ReportId": selectedReportId },
      Callback: callBack_func,
      PathParams: { ReportId: selectedReportId },
    };
    window.loadMicroFrontend_formBuilder(propsData);
  }

  // console.log("sessionIdCurrent9876 ", sessionIdCurrent);
  // console.log("sessionIdCurrent9876 ", selectedReportId);
  // console.log("sessionIdCurrent9876 ", props.data.id);

  function selectReport(reportID) {
    // // console.log("select Report is ", selectedReportId);
    // // console.log("select Report is ",  props.data);
   // props.data.selectId = selectedReportId;
    props.data.selectId = reportID;
    
    setSelectedReportId(reportID);
    if (!window?.loadMicroFrontend) {
      window.loadIntegrator_bam();
    }
    // loaderScript();
    const selectedReport = data?.find(
      (report) => report.report_index === reportID
    );
    if (selectedReport) {
      props.data.style.reportName=selectedReport.report_name;
      props.closeModal(selectedReport.report_name);

    }
    props.closeModal();
  }

  useEffect(() => {
    if (window?.loadMicroFrontend && selectedReportId) {
      loadReport();
    }
  }, [selectedReportId,window.loadMicroFrontend]);

  function selectReportOnClick() {
    if (!window?.loadMicroFrontend) {
      window.loadIntegrator_bam();
    }
    const selectedReport = data?.find(
      (report) => report.report_index === selectedReportId
    );
    if (selectedReport) {
      props.data.selectId=selectedReportId
      props.data.style.reportName=selectedReport.report_name;
      props.closeModal(selectedReport.report_name,"select");
    }
    else{
      props.closeModal(undefined,"select");
    }
  }

  function selectReportListId(reportID) {
    // console.log("Report Id Is ", reportID);
    setSelectedReportId(reportID);
   // props.data.selectId = selectedReportId;
  }

  // // console.log("Report Id is", selectedReportId);
  // // console.log("select Report is ", props.data);

  // // console.log(" Show Loader ", showLoader);

 const handleCloseModal=()=>{
  props.closeModal(undefined,"cancel")
 }
 useEffect(()=>{
  document.getElementById("backdropDiv")?.focus();
  
 },[])
 function handleEscapeKey(e){
  if(e.code === "Escape"){
    handleCloseModal()
  } 
 }


 var totalReport = data.length/5;
 totalReport = Math.ceil(totalReport);

 
 
//  SetStartIdx(0);
//  if(totalReport > 1)
//  SetEndIdx(21);
//  else
//  SetEndIdx(data.length);
//  console.log('llllllllllllll',data.length)

  return (
    <div className={classes.paper} tabIndex={activeTabIndex} onKeyDown={(e) => handleEscapeKey(e)} id="backdropDiv">
      <header
        style={{
          boxShadow: "0px -1.5px 5px grey",
          height: "50px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0px 15px",
          // fontSize: "19px",
        }}
      >
        <span
          // style={{ font: "font: normal normal 600 14px/19px Open Sans" }}
          className={styles.selectReports}
        >
          {t(`${"Select Reports"}`)}
        </span>{" "}
        <span>
          <ClearIcon style={{ cursor: "pointer" }} onClick={handleCloseModal} />
        </span>
      </header>
      <div
        style={{
          width: "751px",
          margin: "auto",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <div
          style={{
            width: "138px",
            maxHeight: "28px",
            border: "1px solid #c4c4c4",
            margin: "8px 0px",
          }}
        >
          <List style={{ padding: 0 }} aria-label="Device settings" className="ListHeader"> 
            <ListItem
              style={{ padding: "0px 5px",marginTop:'-1%' }}
              button
              onClick={handleClickListItem}
              className="ListItemClass"
            >
              <ListItemText
              disableRipple
              title={options[selectedIndex]?.category_name}
              className="ListItemTextClass"
                secondary={
                  // options.length !== 0 && options[selectedIndex].category_name
                  // options.length !== 0 ? options[selectedIndex].category_name : "All Reports"
                  (listItemDefaultText===false)?"General Reports"  : options.length !== 0 && options[selectedIndex].category_name
                }
                classes={{
                  root: classes.listItemText2,
                }}
                //  className={classes.listItemText2}
              ></ListItemText>
              <KeyboardArrowDownIcon className={(lengthListItemText)?classes.keydownarrow2:classes.keydownarrow1}/>
            </ListItem>
          </List>
          
          
          <Menu
            id="lock-menu"
            anchorEl={anchorEl}
            getContentAnchorEl={null}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
            PaperProps={{
              style: {
                // width: '188px',
                marginTop: "2.1%",
                maxHeight: "65%",
                marginLeft: "-2px",
                //
                //drop down width styling goes here based on parent input style 
                 //maxWidth:`350px !important`,
                // top:"-16px !important",
                // left:"642px !important",

                // height:"auto"
              },
            }}
            className={classes.TestingClass}
            //sx={{maxWidth: `${dropDownWidth} !important`}}
          >
           
            <div class="xoxo">
            {Object.keys(options).map((item, index) => (
              <div
              //  key={data[item].id}
              className="testing2"
              >
                <>
                  <MenuItem
                    //  key={options[item].category_name}
                    selected={index === selectedIndex}
                    onClick={(event) => handleMenuItemClick(event, index)}
                    className={classes.menuItemName}
                  >
                   <span 
                   title={options[item].category_name}
                   style={{
                     overflow: "hidden ",
     textOverflow: "ellipsis ",
     whiteSpace: "nowrap ",
     display: "inline-block ",
                    }}
                   >
                     {options[item].category_name}
                     </span>
                  </MenuItem>
                </>
              </div>
            ))}
            </div>
          </Menu>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "200px",
            maxHeight: "28px",
            border: "1px solid #c4c4c4",
            margin: "8px 12px",
            // paddingLeft: "8px",
          }}
        >
          <InputBase
           onKeyDown={ (e)=> { if(e.key==="Enter"){ searchWord() }}}
            inputProps={{"aria-label":"Control Value2"}}
            placeholder="Search"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            style={{flex: "1"}}
          />
          {/* <IconButton> */}
          <span onClick={() => searchWord()} style={{marginTop:"4px", marginRight:"4px", marginLeft:"4px"}}>
            <SearchIcon/>
          </span>
          {/* </IconButton> */}
        </div>
        <div
          style={{
            width: "28px",
            maxHeight: "28px",
            border: "1px solid #c4c4c4",
            margin: "8px 0px",
            display: "flex",
            alignItems: "center",
            marginRight:"4px"
            // marginLeft: "12% !important"

          }}
          onClick={previousPageReport}
        >
          <span style={{marginLeft:"12%",marginTop:"8%"}}>
          {enablePrev ? (
            <ChevronLeftIcon />
          ) : (
            <ChevronLeftIcon color="disabled" />
          )}
          </span>
          {/* <i class="fas fa-chevron-left"></i> */}
        </div>
        <div
          style={{
            width: "28px",
            maxHeight: "28px",
            border: "1px solid #c4c4c4",
            margin: "8px 0px",
            display: "flex",
            alignItems: "center",
            marginLeft: "12% !important"
          }}
          onClick={nextPageReport}
        >
          <span style={{marginLeft:"12%",marginTop:"11%"}}>
          {enableNext ? (
            <ChevronRightIcon />
          ) : (
            <ChevronRightIcon color="disabled" />
          )}
          </span>
        </div>
      </div>

      <div
        style={{
          background: "#FFFFFF 0% 0% no-repeat padding-box",
          border: "1px solid #C4C4C4",
          borderRadius: "2px",
          opacity: "1",
          width: "751px",
          height: "252px",
          margin: "auto",
          verticalAlign: "middle",
        }}
      >
        <List className={classes.root} subheader={<li />}>
          <li className={classes.listSection}>
            <ul className={classes.ul}>
              <ListSubheader
                className={styles.reportSubHeader}
                // style={{
                //   font: "normal normal 600 14px/19px OpenSans-Semibold",
                //   display: "flex",
                //   alignItems: "center",
                //   borderBottom: "1px solid #C4C4C4",
                //   height: "36px",
                //   top:"-1px"
                // }}
              >
                <span className={styles.reportNameSubHeader}>{t(`${"Report Name"}`)}</span>
              </ListSubheader>

              {
              
              
//.splice(startIdx,endIdx)

              !showLoader ? (
                Object.keys(data).map((item) => (
                  <div key={data?.[item]?.id}>
                    {/* {item.toLowerCase().indexOf(filter.toLowerCase()) > -1 ? ( */}
                    <>
                      {/* {// console.log("bam login In ", item)}
                    {// console.log("bam login In ", data[item].report_name)}  */}
                      <ListItem
                        className={
                          data?.[item]?.report_index === selectedReportId
                            ? classes.reportitemSelected
                            : classes.reportitem
                        }
                        // onClick={() => {
                        //   setName(item);
                        // }}

                        onClick={() =>
                          selectReportListId(data[item].report_index)
                        }
                        // ondblclick={()=>selectReport()}

                        onDoubleClick={() =>
                          selectReport(data[item].report_index)
                        }
                        // selectReportListId

                        // onClick={() => {
                        //   alert(`id: ${data[item].id} and name: ${item}`);
                        // }}
                        // item.report_name
                      >
                        {/* <ListItemText primary={`${item}`} /> */}
                        <ListItemText
                          primary={`${data?.[item]?.report_name}`}
                          //  className={classes.listItemText}
                          classes={{
                            root: classes.listItemText,
                          }}
                        />
                      </ListItem>
                      {/* <Divider /> */}
                    </>
                    {/* ) : (
                    ""
                  )} */}
                  </div>
                ))
              ) : showLoader === true ? (
                <div
                  style={{
                    justifyContent: "center",
                    display: "flex",
                    marginTop: "50px",
                  }}
                >
                  {/* <div style={{marginTop:"50%", marginLeft:"50%"}}> */}
                  <CircularProgress />
                </div>
              ) : (
                <></>
              )}
            </ul>
          </li>
        </List>
      </div>

      <footer
        style={{
          paddingLeft: translationStyles1 ? "12px" : "initial",
          display:"flex",
          alignItems:"center",
          justifyContent:"end",
          width: "100%",
          height: "50px",
          color: "gray",
          position: "fixed",
          bottom: 0,
          boxShadow: "0px 1px 10px grey",
          background: "#F5F5F5 0% 0% no-repeat padding-box",
        }}
      >
        <div
          style={{
            width: " 160px",
            float: "right",
            display: "flex",
            justifyContent: "space-evenly",
          }}
        >
          <Button
          disableFocusRipple
          disableRipple
          tabIndex={activeTabIndex} className={`formBuilder-MuiButton-outlined`}
            variant="outlined"
            style={{
              backgroundColor: "#ffffff",
              width: "54px",
              height: "28px",
              fontSize: "12px",
              borderRadius: "2px",
              textTransform: "none",
            }}
            onClick={handleCloseModal}
          >
            {t(`${"Cancel"}`)}
          </Button>
          <Button
          disableFocusRipple
          disableRipple
          tabIndex={activeTabIndex} className={`formBuilder-MuiButton-outlined`}
            variant="contained"
            disabled={data.length == 0 || selectedReportId === undefined}
            style={
              data.length == 0
                ? {
                    backgroundColor: "light-grey",
                    color: "rgba(0, 0, 0, 0.38)",
                    width: "43px",
                    height: "28px",
                    fontSize: "12px",
                    borderRadius: "2px",
                    textTransform: "none",
                  }
                : {
                    backgroundColor: "#0072c6",
                    color: "white",
                    width: "43px",
                    height: "28px",
                    fontSize: "12px",
                    borderRadius: "2px",
                    textTransform: "none",
                  }
            }
            // onClick={()=>selectReport()}
            onClick={() => selectReportOnClick()}
          >
            {t(`${"Select"}`)}
          </Button>
        </div>

        {/* <div
          style={{
            paddingTop: "11px",
            width: "230px",
            position: "inherit",
            right: "15px",
            display: "flex",
            justifyContent: "space-between",
          }}
        ></div> */}
      </footer>
    </div>
  );
};

export default ReportModal;
